/**
 * The dashed, locked hint a product sync upload surface shows where a cell or
 * a tier has no upload target, and why ("Sync this product first", "These
 * sizes have no platen yet", "Store SKU changed", "Set up this product's
 * store SKUs first"). One look for every such place, so a locked slot always
 * reads as locked, never as an empty dropzone (DESIGN.md §15.2).
 *
 * Presentation only: the caller passes the reason, already translated, and
 * any grid placement (`md:col-span-2`) through `className`.
 */
import type { ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LockedHintProps {
  children: ReactNode;
  className?: string;
}

export function LockedHint({ children, className }: LockedHintProps) {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-md border border-dashed bg-muted/20 px-3 py-3 text-[11px] text-muted-foreground',
        className,
      )}
    >
      <Lock className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
